import { gql } from '@apollo/client';

export const CREATE_PAYMENT = gql`
  mutation CreatePayment(
    $serviceId: String!
    $targetId: ID
    # $targetIds: [ID!]
    $paymentMethod: PaymentMethodEnum!
    $cardId: ID
    $amount: Float
    $source: SourceEnum!
    $referrer: PaymentReferrerEnum
    $yigimTemplateGroup: PaymentCreateYigimTemplateGroupEnum
  ) {
    createPayment(
      serviceId: $serviceId
      targetId: $targetId
      # targetIds: $targetIds
      paymentMethod: $paymentMethod
      cardId: $cardId
      amount: $amount
      source: $source
      referrer: $referrer
      yigimTemplateGroup: $yigimTemplateGroup
    ) {
      entity {
        # amount
        redirectUrl
        status
        paymentLegacyId
        paymentDate
        # paymentMethod
        # serviceName
        targetLegacyId
        provider
      }
      errors {
        code
        message
        path
      }
    }
  }
`;

export const CREATE_TERMINAL_PAYMENT = gql`
  mutation CreateTerminalPayment($serviceId: String!, $targetId: ID!) {
    createTerminalPayment(serviceId: $serviceId, targetId: $targetId) {
      entity
      errors {
        code
        message
        path
      }
    }
  }
`;

export const PAY_FOR_AD_BY_PREPAID_BUNDLE = gql`
  mutation PayForAdByPrepaidBundle($adId: ID!) {
    payForAdByPrepaidBundle(adId: $adId) {
      entity
      errors {
        code
        message
        path
      }
    }
  }
`;

export const FINISH_PAYMENT = gql`
  mutation FinishPayment(
    $provider: PaymentProviderEnum!
    $reference: String!
    $cardToken: Boolean
  ) {
    finishPayment(
      provider: $provider
      reference: $reference
      cardToken: $cardToken
    ) {
      entity {
        message
        payment {
          amount
          paymentLegacyId
          serviceId
          serviceName
          paymentMethod
          targetLegacyId
          updatedAt
        }
        success
      }
      errors {
        code
        message
        path
      }
    }
  }
`;
